import {createSlice} from '@reduxjs/toolkit';

import {notificationBuilder} from './reducer';

export type NotificationState = {
  loading: number;
  notifications: {
    messages: any[];
    page: number;
    size: number;
    total: number;
  } | null;
  error: string;
};

const initialState: any = {
  loading: 0,
  notifications: {
    messages: [],
    page: 1,
    size: 10,
    total: 0
  },
  error: ''
};

export const notificationSlicer = createSlice({
  name: 'notification',
  initialState,
  reducers: {},
  extraReducers: notificationBuilder
});

export default notificationSlicer.reducer;
